//react
import { Dispatch, SetStateAction, useState } from "react";

//interfaces
import {
  IHU,
  IProductHU,
  IReserve,
  IServiceHU,
  IUserColab,
} from "../../Interfaces";

//components
import { LogoutIcon } from "../MenuIcons/LogoutIcon";
import { Container, DeleteModel } from "./styles";
import { FaRegTrashAlt } from "react-icons/fa";

//provider
import { useUser } from "../../Providers/User";
import ModalElement from "../Modal";
import Button from "../Button";

interface CloseButtonProps {
  logoutButton?: boolean;
  deleteFunctionForId?: (id: number) => void;
  deleteHU?: (HU: IHU) => void;
  deleteProductOrService?: (
    productOrServiceToBeRemoved: IProductHU | IServiceHU,
    HU: IHU
  ) => void;
  id?: number;
  HU?: IHU;
  productOrServiceToBeRemoved?: IProductHU | IServiceHU;
  deleteReserve?: (reserve: IReserve, HU: IHU) => void;
  reserveToBeDeleted?: IReserve;
  deleteColab?: (colab: IUserColab) => void;
  closeModal?: () => void;
  colab?: IUserColab;
}

interface IDeleteModalProps {
  onClick: () => void;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

const DeleteModal = ({ onClick, setShowModal }: IDeleteModalProps) => {
  return (
    <DeleteModel className="modalContent">
      <p>Tem certeza que deseja deletar??</p>
      <Button className="delete" type="button" onClick={() => onClick()} small>
        Sim
      </Button>
      <Button
        className="noDelete"
        type="button"
        onClick={() => setShowModal(false)}
        small
      >
        Não
      </Button>
    </DeleteModel>
  );
};

export const CloseButton = ({
  logoutButton,
  deleteFunctionForId,
  deleteHU,
  deleteProductOrService,
  id,
  HU,
  productOrServiceToBeRemoved,
  deleteReserve,
  reserveToBeDeleted,
  closeModal,
  deleteColab,
  colab,
}: CloseButtonProps) => {
  const { logout } = useUser();
  const [showModal, setShowModal] = useState<boolean>(false);

  const onClick = () => {
    if (deleteFunctionForId && id) {
      deleteFunctionForId(id);
    } else if (deleteHU && HU) {
      deleteHU(HU);
    } else if (productOrServiceToBeRemoved && deleteProductOrService && HU) {
      deleteProductOrService(productOrServiceToBeRemoved, HU);
    } else if (logoutButton) {
      logout();
    } else if (closeModal) {
      closeModal();
    } else if (deleteReserve && reserveToBeDeleted && HU) {
      deleteReserve(reserveToBeDeleted, HU);
    } else if (deleteColab && colab) {
      deleteColab(colab);
    }
    setShowModal(false);
  };

  return !!logoutButton ? (
    <Container>
      <LogoutIcon onClick={onClick} />
    </Container>
  ) : closeModal ? (
    <Container>
      <button type="button" className="button" onClick={onClick}>
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.875 6.125L6.125 21.875"
            stroke="#152044"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.875 21.875L6.125 6.125"
            stroke="#152044"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </Container>
  ) : (
    <Container>
      <button
        type="button"
        className="button trashButton"
        onClick={() => setShowModal(true)}
      >
        <FaRegTrashAlt />
      </button>
      <ModalElement closeModal={() => setShowModal(false)} isOpen={showModal}>
        <DeleteModal onClick={onClick} setShowModal={setShowModal} />
      </ModalElement>
    </Container>
  );
};
